import { render, staticRenderFns } from "./ModalEditEvent.vue?vue&type=template&id=379f34a8"
import script from "./ModalEditEvent.vue?vue&type=script&lang=js"
export * from "./ModalEditEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports